import gql from 'graphql-tag';

import webpageFragment from '../fragments/webpageFragment';

export const mutationUpdateWebpage = gql`
  mutation updateWebpage(
    $id: DokkioID!
    $dokkioTagIDs: [DokkioID!]
    $clippedAt: DateTime
  ) {
    updateWebpage(
      id: $id
      dokkioTagIDs: $dokkioTagIDs
      clippedAt: $clippedAt
    ) {
      ...webpageFragment
    }
  }
  ${webpageFragment}
`;
export default mutationUpdateWebpage;
